export default {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<button type=\"button\" class=\"tc-ctl-3d-btn tc-float-btn\" title=\"[[threed.tip]]\"></button>";
},"useData":true}